import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { useQueryClient } from '@tanstack/react-query';
import { Switch } from './ui/switch';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const ITEMS = [
  ['review_launch_bonus_active', 'Review launch bonus',
    (c) => `ON: every approved review earns ${c.review_launch_bonus_pts} pts. OFF: ${c.review_approval_pts} pts.`],
  ['review_like_verified_only', 'Verified buyers only (likes earn points)',
    () => 'ON: a like only earns the author points if the liker has a delivered order of that product.'],
];

// Instant-save toggles for review rewards (independent of the SAVE CONFIG draft).
export function ReviewRewardSwitches({ config, onSaved }) {
  const [busy, setBusy] = useState(null);
  const queryClient = useQueryClient();
  const flip = async (key, value) => {
    setBusy(key);
    try {
      const { data } = await axios.patch(`${API_URL}/api/loyalty/config`, { [key]: value }, { withCredentials: true });
      onSaved(data);
      queryClient.invalidateQueries({ queryKey: ['loyalty', 'review-rewards'] });
      toast.success(`${ITEMS.find((i) => i[0] === key)[1]}: ${value ? 'ON' : 'OFF'}`);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Save failed');
    } finally { setBusy(null); }
  };
  return (
    <div className="mt-6 pt-4 border-t border-[#2A0F3D] space-y-3" data-testid="review-reward-switches">
      <p className="text-[#6B8E73] font-mono text-xs uppercase">// Review rewards · saves instantly</p>
      {ITEMS.map(([key, label, help]) => (
        <div key={key} className="flex items-start justify-between gap-4">
          <div className="min-w-0">
            <p className="text-[#A3C7A8] font-mono text-sm">{label}</p>
            <p className="text-[#4B6B52] font-mono text-[11px]">{help(config)}</p>
          </div>
          <Switch checked={!!config[key]} disabled={busy === key} onCheckedChange={(v) => flip(key, v)} className="data-[state=unchecked]:bg-[#3A2A48] border border-[#6B8E73]/50" data-testid={`switch-${key}`} />
        </div>
      ))}
    </div>
  );
}
